import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, connect } from "react-redux";
import moment from "moment";
// eslint-disable-next-line object-curly-newline
import { Button, Row, Col } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { fetchReportStart } from "store/reports/actions";
import CustomPagination from "components/Common/CustomPagination";

import Loader from "components/Common/Loader";
import SendReportEmail from "./SendReportEmail";
import AvFieldSelect from "components/Common/AvFieldSelect";
import DownloadFileType from "./DownloadFileType";
import CountryDropDown from "components/Common/CountryDropDown";
import ClientDropDown from "components/Common/Filters/ClientDropDown";
import SearchableComponent from "pages/Transactions/Forex/internalTransfer/SearchableComponents";
import { getClients } from "apis/client";

function UsersAddModal(props) {
  console.log(props.reportsPermissions.getAssigned);
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);
  const [selectedValues, setSelectedValues] = useState({});
  const [reportType, setReportType] = useState("");
  const [showStatus, setShowStatus] = useState(false);
  const handleShowStatus = (type) => {
    if (type === "deposit-status" || type === "deposit-status-fx" || type === "withdrawals-status-fx" || type === "withdrawals-status") {
      setShowStatus(true);
    } else {
      setShowStatus(false);
    }
  };

  const submitReportSearch = (e, values = {}) => {
    const updatedReportType = values.reportType || reportType;

    const searchValues = {
      ...selectedValues,
      reportType: updatedReportType,
      country: selectedValues.country || "",
      customerId: selectedValues.customerId || "",
      parentId: selectedValues.parentId || "",
      ...values,
    };

    dispatch(fetchReportStart(searchValues));
    props.setReportColumns(updatedReportType);
    setSelectedValues(searchValues);
    props.setPayload({
      ...searchValues,
      type: updatedReportType,
    });
  };
  const paginationLoad = (page) => {
    dispatch(
      fetchReportStart({
        ...selectedValues,
        page,
        limit: sizePerPage,
      })
    );
  };
  useEffect(() => {
    if (props.type && props.status) {
      let newReportType = "deposits";

      if (props.type === "LIVE" && props.status === "IN_PROGRESS") {
        newReportType = "live-pending-plans";
      } else if (props.type === "LIVE" && props.status === "APPROVED") {
        newReportType = "live-approved-plans";
      } else if (props.type === "LIVE" && props.status === "REJECTED") {
        newReportType = "live-rejected-plans";
      } else if (props.type === "DEMO" && props.status === "IN_PROGRESS") {
        newReportType = "demo-pending-plans";
      } else if (props.type === "DEMO" && props.status === "APPROVED") {
        newReportType = "demo-approved-plans";
      } else if (props.type === "DEMO" && props.status === "REJECTED") {
        newReportType = "demo-rejected-plans";
      }

      setReportType(newReportType);
    }
  }, [props.type, props.status]);

  useEffect(() => {
    const defaultValues = {
      reportType,
      dateFrom: moment().subtract(1, "months").format("YYYY-MM-DD"),
      dateTo: moment().add(1, "day").format("YYYY-MM-DD"),
    };
    if (reportType) {
      submitReportSearch(null, defaultValues);
    }
  }, [reportType]); 

  useEffect(() => {
    if (selectedValues && selectedValues.reportType) {
      dispatch(
        fetchReportStart({
          ...selectedValues,
          page: 1,
          limit: sizePerPage,
        })
      );
    }
  }, [sizePerPage]);
  const defaultValues = {
    reportType: "deposits",
    dateFrom: moment().subtract(1, "months").format("YYYY-MM-DD"),
    dateTo: moment().add(1, "day").format("YYYY-MM-DD"),
  };
  useEffect(()=> {
    console.log("props", props);
  }, [props]);
  return (
    <React.Fragment>
      <div className=" me-2 mb-2">
        <div className="position-relative">
          <AvForm
            className="p-1"
            onValidSubmit={(e, v) => {
              submitReportSearch(e, v);
            }}
            model={defaultValues}
          >
            <Row>
              <Col xs={12} md={4} lg={2}>
                <label>Report Type</label>
                <AvFieldSelect
                  type="select"
                  name="reportType"
                  required
                  value={reportType}
                  onChange={(e) => {
                    setReportType(e);
                    handleShowStatus(e);
                  }}
                  options={[
                    {
                      value: "deposits",
                      label: props.t("Deposits By Login"),
                    },
                    {
                      value: "demo-pending-plans",
                      label: props.t("In Progress Demo Plans"),
                    },
                    {
                      value: "demo-approved-plans",
                      label: props.t("Success Demo Plans"),
                    },
                    {
                      value: "demo-rejected-plans",
                      label: props.t("Fail Demo Plans"),
                    },
                    {
                      value: "live-pending-plans",
                      label: props.t("In Progress Live Plans"),
                    },
                    {
                      value: "live-approved-plans",
                      label: props.t("Success Live Plans"),
                    },
                    {
                      value: "live-rejected-plans",
                      label: props.t("Fail Live Plans"),
                    },
                    
                  ]}
                  errorMessage={props.t("please select report Type")}
                  validate={{ required: { value: true } }}
                >
                  {/* <option value="">{props.t("Select Report")}</option>
                  <option value="deposits">{props.t("Deposits By Login")}</option>
                  <option value="client-deposits">{props.t("Deposits By Client")}</option>
                  <option value="withdrawals">{props.t("Withdrawals By Login")}</option>
                  <option value="client-withdrawals">{props.t("Withdrawals By Client")}</option>
                  <option value="commission">{props.t("Commission")}</option>
                  <option value="credit-in">{props.t("Credit In")}</option>
                  <option value="credit-out">{props.t("Credit Out")}</option>
                  <option value="unfunded-accounts">{props.t("Unfunded Accounts")}</option>
                  <option value="summary">{props.t("Summary")}</option>
                  <option value="lead-converted">{props.t("Lead Converted")}</option>
                  <option value="lead-call-status">{props.t("Lead Call Status")}</option>
                  <option value="last-login">{props.t("Last Login")}</option> */}
                </AvFieldSelect>
              </Col>
              <Col xs={12} md={4} lg={2}>
                <AvField
                  name="dateFrom"
                  label={props.t("Date From")}
                  type="date"
                  errorMessage={props.t("Select date From")}
                  validate={{ required: { value: true } }}
                />
              </Col>
              <Col xs={12} md={4} lg={2}>
                <AvField
                  name="dateTo"
                  label={props.t("Date To")}
                  type="date"
                  errorMessage={props.t("Select date To")}
                  validate={{ required: { value: true } }}
                />
              </Col>

              <Col xs={12} md={4} lg={2}>
                <AvFieldSelect
                  type="select"
                  name="agent"
                  label={props.t("Agent")}
                  value={props.reportsPermissions.getAssigned && props.userData._id}
                  options={
                    props.reportsPermissions.getAssigned && !props.reportsPermissions.get ? (
                      [
                        {
                          label: `${props.userData.firstName} ${props.userData.lastName}`,
                          value: props.userData._id,
                        },
                      ]
                    ) : (
                      [
                        {
                          label: props.t("All"),
                          value: "",
                        },
                        ...props.salesAgent.map((obj) => ({
                          label: `${obj.firstName} ${obj.lastName}`,
                          value: obj._id,
                        })),
                      ]
                    )
                  }    
                  errorMessage={props.t("Select Agent")}
                ></AvFieldSelect>
              </Col>
              {showStatus ? <Col xs={12} md={4} lg={2}>
                <AvFieldSelect
                  name="status"
                  label={props.t("Status")}
                  type="select"
                  errorMessage={props.t("Select Status")}
                  // validate={{ required: { value: true } }}
                  options={[
                    {
                      label: props.t("All"),
                      value: "",
                    },
                    {
                      label: props.t("Approved"),
                      value: "APPROVED",
                    },
                    {
                      label: props.t("Rejected"),
                      value: "REJECTED",
                    },
                    {
                      label: props.t("Pending"),
                      value: "PENDING",
                    },
                  ]}
                ></AvFieldSelect>
              </Col> : null}
              {
                ["daily-net-deposit", "new-client-deposits", "summary"].includes(reportType) && <Col xs={12} md={6} lg={4}>
                  <CountryDropDown
                    defaultValue={selectedValues.country}
                    countryChangeHandler={(value) => {
                      setSelectedValues({
                        ...selectedValues,
                        country: value.value,
                      });
                    }} />
                </Col>
              }
            </Row>
            {["summary"].includes(reportType) && <Row>
              <Col xs={12} md={6} lg={6}>
                <ClientDropDown
                  defaultValue={selectedValues.customerId}
                  clientChangeHandler={(value) => {
                    setSelectedValues({
                      ...selectedValues,
                      customerId: value.value,
                    });
                  }}
                />
              </Col>
              <Col xs={12} md={6} lg={6}>
                <div className="mb-3">
                  <SearchableComponent
                    isRequired
                    name="parentId"
                    label={props.t("IB")}
                    onChange={(e) => {
                      setSelectedValues({
                        ...selectedValues,
                        parentId: e?.value ?? "",
                      });
                    }}
                    getData={async (payload) => getClients({
                      payload: {
                        fxType: "IB",
                        ...payload
                      }
                    })?.then((res) => (res?.result?.docs || []))}
                    mapper={(doc) => (
                      {
                        label: `${doc.firstName} ${doc.lastName}`,
                        value: `${doc._id}`
                      }
                    ) || []}
                  />
                </div>
              </Col>
            </Row>}
            <Row className="text-center d-flex justify-content-center align-items-center my-3" style={{
              maxWidth: "100%",
            }}>
              <div style={{
                maxWidth: 400,
              }}>
                {props.addLoading ? (
                  <Loader />
                ) : (
                  <Button
                    type="submit"
                    color="primary"
                    className="w-100 py-2"
                    disabled={props.loading || !reportType}
                  >
                    {props.t("Search")}
                  </Button>
                )}
              </div>
            </Row>
            <div className="d-flex justify-content-end gap-2">
              <DownloadFileType selectedValues={selectedValues} />
              <SendReportEmail reportValues={selectedValues} />
            </div>
          </AvForm>
        </div>
      </div>
      <div className="table-rep-plugin">
        <div className="table-responsive mb-0" data-pattern="priority-columns">
          {props.children}
          <CustomPagination
            {...props.reportsReducer}
            setSizePerPage={setSizePerPage}
            sizePerPage={sizePerPage}
            onChange={paginationLoad}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  loading: state.reportsReducer.loading || false,
  salesAgent: state.usersReducer.salesAgent || [],
  reportsReducer: state.reportsReducer || {},
  userData: state.Profile.userData || {},
  reportsPermissions:state.Profile.permissions?.reports || {},
});
export default connect(mapStateToProps, null)(withTranslation()(UsersAddModal));
